(function () {
  'use strict';

  if (window.julysnowClickVideoBound) return;
  window.julysnowClickVideoBound = true;

  var wrapperSelector = '[data-click-to-load-video]';

  // Initial page media gets one head link. Quick-view/section media loads it once on demand.
  var stylesUrl = document.currentScript && document.currentScript.getAttribute('data-video-styles');
  function ensureVideoStyles() {
    if (!stylesUrl || document.getElementById('julysnow-click-video-styles')) return;
    var link = document.createElement('link');
    link.id = 'julysnow-click-video-styles';
    link.rel = 'stylesheet';
    link.href = stylesUrl;
    document.head.appendChild(link);
  }
  if (document.querySelector(wrapperSelector)) {
    ensureVideoStyles();
  } else if (stylesUrl && !document.getElementById('julysnow-click-video-styles')) {
    var videoStyleObserver = new MutationObserver(function (records) {
      var hasVideo = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(wrapperSelector) || node.querySelector(wrapperSelector));
        });
      });
      if (hasVideo) {
        ensureVideoStyles();
        videoStyleObserver.disconnect();
      }
    });
    videoStyleObserver.observe(document.body, { childList: true, subtree: true });
  }

  function pauseWrapper(wrapper) {
    var video = wrapper && wrapper.querySelector('video');
    if (video) video.pause();
  }

  function pauseAll() {
    document.querySelectorAll(wrapperSelector).forEach(pauseWrapper);
  }

  function playFromClick(event) {
    var button = event.target.closest('[data-click-video-play]');
    if (!button) return;

    var wrapper = button.closest(wrapperSelector);
    if (!wrapper) return;

    event.preventDefault();
    event.stopPropagation();

    var container = wrapper.querySelector('.t4s-pr');
    var video = container && container.querySelector('video');
    if (!container) return;

    if (!video) {
      var template = container.querySelector('template');
      if (!template) return;
      var fragment = template.content.cloneNode(true);
      video = fragment.querySelector('video');
      if (!video) return;

      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      video.setAttribute('preload', 'none');
      video.controls = true;
      video.setAttribute('controls', 'controls');
      video.setAttribute('playsinline', '');
      if (wrapper.getAttribute('data-enable-video-muting') === 'true') {
        video.muted = true;
        video.setAttribute('muted', '');
      }
      if (wrapper.getAttribute('data-enable-video-looping') === 'true') {
        video.loop = true;
      }
      video.tabIndex = 0;
      video.setAttribute('aria-label', button.getAttribute('aria-label').replace('Play video for', 'Video for'));
      video.id = button.getAttribute('aria-controls');
      video.classList.add('julysnow-click-video__player');
      container.appendChild(video);
      template.remove();
      container.setAttribute('loaded', 'true');
      wrapper.classList.add('julysnow-click-video--loaded');
      wrapper.addEventListener('mediaHidden', function () { video.pause(); });
      wrapper.addEventListener('xrLaunch', function () { video.pause(); });

      var poster = container.querySelector('.t4s_ratio.t4s-product__media');
      if (poster) poster.style.visibility = 'hidden';
    }

    button.hidden = true;
    video.focus();
    // Calling play synchronously here keeps the user's click activation.
    // If playback is declined, native controls still allow the user to play.
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  document.addEventListener('click', playFromClick, true);
  document.addEventListener('xrLaunch', pauseAll, true);
  document.addEventListener('shopify_xr_launch', pauseAll);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(wrapperSelector).forEach(pauseWrapper);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pauseAll();
  });
}());
